export const ListServicesOptions = [
    { value: 'pickup', label: 'Pickup' },
    { value: 'delivery', label: 'Delivery' },
    { value: 'dine_in', label: 'Dine In' },
    { value: 'table_booking', label: 'Table Booking' },
];
export const ListServicesOptionsNoB = [
    { value: 'pickup', label: 'Pickup' },
    { value: 'delivery', label: 'Delivery' },
    { value: 'dine_in', label: 'Dine In' },
];
export const ListPaymentsOptions = [
    { value: 'cash', label: 'Cash' },
    { value: 'card', label: 'Card' },
    { value: 'stripe', label: 'Card/Wallet' },
    { value: 'paypal', label: 'PayPal' },
    { value: 'cardconnect', label: 'CardConnect' },
    { value: 'paygate_payweb', label: 'Paygate Payweb' },
    { value: 'poli_pay', label: 'POLi Pay' },
    { value: 'ipay88', label: 'IPay 88' },
    { value: 'bambora_apac', label: 'Bambora APAC' },
    { value: 'bambora_na', label: 'Worldline' },
    { value: 'pesapal', label: 'Pesapal' },
    { value: 'ath_movil', label: 'ATH Móvil' },
    { value: 'checkout', label: 'Checkout' },
    { value: 'checkout_apple_pay', label: 'Apple Pay (Checkout.com)' },
    { value: 'checkout_google_pay', label: 'Google Pay (Checkout.com)' },
    { value: 'stripe_digital_wallet', label: 'Google/Apple Pay' },
    { value: 'razor_pay', label: 'Razor Pay' },
    { value: 'authorized', label: 'Authorize.net' },
    { value: 'gravity', label: 'Gravity' },
    { value: 'elavon', label: 'Elavon' },
    { value: 'red_dot', label: 'Red Dot Payment' },
    { value: 'gkash', label: 'Gkash' },
    { value: 'sgepay', label: 'SGEPAY' },
    { value: 'payway', label: 'ABA Pay' },
    { value: 'bancontact', label: 'Bancontact' },
    { value: 'swish', label: 'Swish' },
    { value: 'cabbagepay', label: 'CabbagePay' },
    { value: 'fiserv', label: 'Fiserv' },
    { value: 'viva_wallet', label: 'Viva Wallet' },
    { value: 'paymongo', label: 'PayMongo' },
];
export const ListPaymentLogosOptions = [
    { value: 'american-express', label: 'American Express (light)' },
    { value: 'amex-dark', label: 'American Express (dark)' },
    { value: 'checkout_apple_pay', label: 'Apple Pay (Checkout.com)' },
    { value: 'checkout_apple_pay_dark', label: 'Apple Pay (Checkout.com) - dark' },
    { value: 'discover', label: 'Discover Network (light)' },
    { value: 'discover-dark', label: 'Discover Network (dark)' },
    { value: 'bancontact', label: 'Bancontact' },
    { value: 'checkout_google_pay', label: 'Google Pay (Checkout.com)' },
    { value: 'mastercard', label: 'Mastercard' },
    { value: 'paygate', label: 'Paygate' },
    { value: 'payway', label: 'ABA Pay' },
    { value: 'paypal', label: 'PayPal' },
    { value: 'poli', label: 'POLi Pay' },
    { value: 'stripe-dark', label: 'Stripe (Dark)' },
    { value: 'stripe-light', label: 'Stripe (Light)' },
    { value: 'swish', label: 'Swish' },
    { value: 'cabbagepay', label: 'CabbagePay' },
    { value: 'visa', label: 'Visa' },
    { value: 'paymongo', label: 'PayMongo' },
];
export const ListOrderTimesOptions = [
    { value: 'now', label: 'Now' },
    { value: 'later', label: 'Later' },
];
//# sourceMappingURL=restaurant.js.map